import { FC, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { LandscapeAboutCommittedBuyersAddPartnerTemplate } from '../../templates';
import { LandscapeBuyerRelationType } from '../../../store/landscapeAPI/landscape/landscape-buyer-relation-type';
import { DEFAULT_CONTEXT_ID, getUUID } from '../../../utils/UUID';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../store/store';
import { LandscapeSupportersSaveRequestDto } from '../../../store/tradeAPI/commodity/dto/request/landscape-suporters-save-request.dto';
import { saveCompactSupporter } from '../../../store/tradeAPI/commodity/reducers/landscape-supporters.slice';
import { LandscapeSupportersResponseDto } from '../../../store/tradeAPI/commodity/dto/response/landscape-suporters-response.dto';
import Spinner from '../../atoms/Spinner/Spinner';

interface LandscapeAboutCommittedBuyersAddPartnerPageProps {}

const LandscapeAboutCommittedBuyersAddPartnerPage: FC<
  LandscapeAboutCommittedBuyersAddPartnerPageProps
> = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();

  const [supporter, setSupporter] = useState<LandscapeSupportersResponseDto>({
    compactId: id ?? '',
    organizationId: '',
    relationType: LandscapeBuyerRelationType.Funders,
    id: getUUID(),
    versionId: 0,
    createdByUserId: '',
    createdOnDateTimeUtc: '',
    language: '',
    published: true,
  });

  const { status: supporterStatus } = useSelector(
    (state: RootState) => state.landscapeSupportersSlice
  );

  const callbackFn = async (supporter: LandscapeSupportersResponseDto) => {
    const landscapeSupporterToSave: LandscapeSupportersSaveRequestDto = {
      organizationId: supporter.organizationId,
      compactId: supporter.compactId,
      commodityId: DEFAULT_CONTEXT_ID,
      relationType: supporter.relationType,
      id: supporter.id,
      published: supporter.published,
    };
    await dispatch(saveCompactSupporter(landscapeSupporterToSave));
    navigate(`/landscapes/edit/${id}/about/committed-buyers`);
  };

  const handleOnChange = (supporter: LandscapeSupportersResponseDto) => {
    setSupporter(supporter);
  };

  if (supporterStatus === 'loading') {
    return <Spinner />;
  }

  return (
    <LandscapeAboutCommittedBuyersAddPartnerTemplate
      callbackFn={callbackFn}
      supporter={supporter}
      handleOnChange={handleOnChange}
    />
  );
};

export default LandscapeAboutCommittedBuyersAddPartnerPage;
